import React from 'react';
import { useNavigate } from 'react-router-dom';
import TypeHistoryPage from './TypeHistoryPage';

const TypeHistoryPageWrapper = () => {
  const navigate = useNavigate();
  return <TypeHistoryPage navigate={navigate} />;
};

export default TypeHistoryPageWrapper;
